
import { useState ,useEffect} from "react";
import {
  Drawer,
  Box,
  IconButton,
  CircularProgress,
  Typography,
  Modal,
  Button
} from "@mui/material";
import profilecross from "../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../components/CustomText";
import SelectDropdown from "../../../components/MultiSelectionDropdown";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/CustomButton";
import { BASE_URL } from "../../../components/BaseUrl";
import { decryptToken } from "../../../Utlis/Encryption";
import { toast } from "react-hot-toast";
import { useRef } from "react";
import { getApiMessage } from "../../../utils/messageHandler";
import document1 from "../../../assets/document1.svg";
import imageicon from "../../../assets/imageicon.png";
import Webcam from "react-webcam";
import { convertLocalDateTimeToUTC } from "../../../components/dateTimeUtils";

const GenerateRequestDrawer = ({ open, onClose, refreshList }) => {
  const { t } = useTranslation();
  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
const [file, setFile] = useState(null);
const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);
const [cameraOpen, setCameraOpen] = useState(false);
const webcamRef = useRef(null);

const fileInputRef = useRef(null);

const triggerFileSelect = () => {
  console.log("🟢 triggerFileSelect fired");
  // alert("Opening file picker...");
  if (fileInputRef.current) {
    fileInputRef.current.click();
  } else {
    console.warn("⚠️ fileInputRef is null");
  }
};
  const initialFormValues = {
  request_type: "",
  subject: "",
  description: "",
  leave_reason_code: "",
  start_date: "",
  end_date: "",
  partial: false,
  partial_start: "",
  partial_end: "",
  current_days: [],
  current_start_time: "",
  current_end_time: "",
  effective_from: "",
  details: "",
  reason: "",
   file_url: "", 
};

const [formValues, setFormValues] = useState(initialFormValues);

// Reset when drawer opens
useEffect(() => {
  if (open) {
    setFormValues(initialFormValues);
    setFile(null);
    setCameraOpen(false);
  }
}, [open]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleDropdownChange = ({ target: { name, value } }) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value.length ? value[0] : "",
    }));
  };

  const handleMultiSelectChange = ({ target: { name, value } }) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
  if (!formValues.request_type) {
    toast.error(t("requests.requestTypeRequired") || "Request type is required");
    return;
  }

  // 🔹 Validate required LEAVE fields
  if (formValues.request_type === "LEAVE") {
    if (!formValues.leave_reason_code) {
      toast.error(t("requests.leaveReasonRequired") || "Leave reason is required");
      return;
    }
    if (!formValues.start_date) {
      toast.error(t("requests.startDateRequired") || "Start date is required");
      return;
    }
    if (!formValues.end_date) {
      toast.error(t("requests.endDateRequired") || "End date is required");
      return;
    }
    if (formValues.partial && (!formValues.partial_start || !formValues.partial_end)) {
      toast.error(t("requests.partialTimeRequired") || "Partial start and end time are required");
      return;
    }
  }

  // 🔹 Validate required SCHEDULE_CHANGE fields
  if (formValues.request_type === "SCHEDULE_CHANGE") {
    if (!formValues.current_days || formValues.current_days.length === 0) {
      toast.error(t("requests.currentDaysRequired") || "Current days are required");
      return;
    }
    if (!formValues.current_start_time) {
      toast.error(t("requests.currentStartTimeRequired") || "Current start time is required");
      return;
    }
    if (!formValues.current_end_time) {
      toast.error(t("requests.currentEndTimeRequired") || "Current end time is required");
      return;
    }
    if (!formValues.effective_from) {
      toast.error(t("requests.effectiveFromRequired") || "Effective from date is required");
      return;
    }
  }

  // 🔹 Validate required GENERIC_HR fields
  if (formValues.request_type === "GENERIC_HR") {
    if (!formValues.subject) {
      toast.error(t("requests.subjectRequired") || "Subject is required");
      return;
    }
    if (!formValues.description) {
      toast.error(t("requests.detailsRequired") || "Details are required");
      return;
    }
  }

  // 🔹 Validate dates
  if (formValues.start_date && formValues.end_date) {
    const start = new Date(formValues.start_date);
    const end = new Date(formValues.end_date);

 if (end < start) {
  toast.error(t("requests.dateError"));
  return;
}
  }

  // 🔹 Validate times (Schedule Change or Partial Leave)
  if (formValues.current_start_time && formValues.current_end_time) {
    if (formValues.current_end_time <= formValues.current_start_time) {
  toast.error(t("requests.timeError"));      return;
    }
  }

  // 🔹 Validate partial times
  if (formValues.partial && formValues.partial_start && formValues.partial_end) {
    if (formValues.partial_end <= formValues.partial_start) {
   toast.error(t("requests.partialTimeError"));
      return;
    }
  }

  const toUtcTimeValue = (timeValue) => {
    if (!timeValue) return "";
    const utcValue = convertLocalDateTimeToUTC(timeValue);
    return utcValue || "";
  };

  /** Postgres `TIME` columns (sched_current_start_time/end_time) reject a full ISO
   * timestamp — convert local → UTC for the correct hour, then keep just "HH:mm:ss". */
  const toUtcTimeOnlyValue = (timeValue) => {
    const utcIso = toUtcTimeValue(timeValue);
    if (!utcIso) return "";
    const match = utcIso.match(/T(\d{2}:\d{2}:\d{2})/);
    return match ? match[1] : "";
  };

    
    try {
      setSaving(true);

      let payload = {};

      if (formValues.request_type === "LEAVE") {
        payload = {
          type: "LEAVE",
    leave_reason_code: formValues.leave_reason_code,   // ✅ added
          start_date: formValues.start_date,
          end_date: formValues.end_date,
          partial: formValues.partial,
          ...(formValues.partial && {
            partial_start: toUtcTimeOnlyValue(formValues.partial_start),
            partial_end: toUtcTimeOnlyValue(formValues.partial_end),
          }),
          reason: formValues.reason,
          subject: formValues.subject,
             file_url: formValues.file_url, 
        };
      } else if (formValues.request_type === "SCHEDULE_CHANGE") {
        payload = {
          type: "SCHEDULE_CHANGE",
            //   leave_reason_code: formValues.leave_reason_code,   // ✅ added

          current_days: formValues.current_days,
          current_start_time: toUtcTimeOnlyValue(formValues.current_start_time),
          current_end_time: toUtcTimeOnlyValue(formValues.current_end_time),
          effective_from: formValues.effective_from,
          reason: formValues.reason,
          subject: formValues.subject,
              file_url: formValues.file_url, // ✅ Added

        };
      } else if (formValues.request_type === "GENERIC_HR") {
        payload = {
          type: "GENERIC_HR",
            //   leave_reason_code: formValues.leave_reason_code,   // ✅ added

          subject: formValues.subject,
          details: formValues.description,
           file_url: formValues.file_url, 
        };
      }

      const res = await fetch(`${BASE_URL}/requests/v1/requests`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const json = await res.json();
      if (!res.ok || json.error) {
        // Show backend message in appropriate language
        toast.error(getApiMessage(json, "Failed to generate request"));
      } else {
        toast.success(getApiMessage(json, "Request generated successfully!"));
        onClose();
        refreshList?.();
      }
    } catch (err) {
      console.error("❌ Error generating request:", err);
      toast.error(getApiMessage({ message: err.message }, "Error generating request"));
    } finally {
      setSaving(false);
    }
  };

const handleFileUpload = async (selectedFile) => {
  if (!selectedFile) {
    console.warn("⚠️ No file selected");
    return;
  }

  const isPdf = selectedFile.type === "application/pdf";
  const key = isPdf ? "pdf" : "image";
  const uploadUrl = isPdf
    ? `${BASE_URL}/upload/pdf`
    : `${BASE_URL}/upload/image`;

  const data = new FormData();
  data.append(key, selectedFile);
  console.log("🔗 Upload URL:", uploadUrl);

  try {
    console.log("🚀 Upload started...");
    setUploading(true);

    const res = await fetch(uploadUrl, {
      method: "POST",
      body: data,
    });

    console.log("📤 Upload response status:", res.status);
    const json = await res.json();
    console.log("✅ Upload response JSON:", json);

    if (json?.data?.url) {
      setFile(selectedFile);
      setFormValues((prev) => ({ ...prev, file_url: json.data.url }));
      toast.success(t("requests.uploadSuccess"));
      console.log("🌐 Uploaded URL:", json.data.url);
    } else {
    toast.error(t("requests.uploadNoUrl"));
      console.error("⚠️ Upload returned invalid response:", json);
    }
  } catch (err) {
    console.error("❌ Upload error:", err);
    toast.error(t("requests.uploadError"));
  } finally {
    console.log("🕓 Upload finished — hiding spinner");
    setUploading(false);
  }
};

const handleFileInputChange = (e) => {
  const selectedFile = e.target.files[0];
  console.log("🔵 File input triggered:", selectedFile);
  if (selectedFile) {
    handleFileUpload(selectedFile);
  }
};

const handleCapturePhoto = () => {
  const imageSrc = webcamRef.current?.getScreenshot();
  if (!imageSrc) {
    toast.error(t("requests.captureError") || "Failed to capture image");
    return;
  }

  // Convert base64 to File
  fetch(imageSrc)
    .then((res) => res.blob())
    .then((blob) => {
      const file = new File(
        [blob],
        `camera_${Date.now()}.jpg`,
        { type: "image/jpeg" }
      );
      setCameraOpen(false);
      handleFileUpload(file);
    })
    .catch((err) => {
      console.error("❌ Error converting image:", err);
      toast.error(t("requests.captureError") || "Error processing captured image");
    });
};





  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: 600, maxWidth: "100%", display: "flex", flexDirection: "column" },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1.5,
          borderBottom: "1px solid #E0E0E0",
          backgroundColor: "#f5f6f7",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 600,
              color: "#172B4D",
            }}
          >
            {t("addHeading") || "Generate Request"}
          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ p: 3, flexGrow: 1, overflowY: "auto" }}>
        {/* Request Type */}
        <Box mb={2}>
          <label className="field_label">
            {t("labels.type")} <span style={{ color: "red" }}>*</span>
          </label>
          <SelectDropdown
            name="request_type"
            values={formValues.request_type ? [formValues.request_type] : []}
            onChange={handleDropdownChange}
            options={[
              { label: t("options.leave"), value: "LEAVE" },
              { label: t("options.scheduleChange"), value: "SCHEDULE_CHANGE" },
              { label: t("options.genericHR"), value: "GENERIC_HR" },
            ]}
          />
        </Box>

        {/* Subject */}
        <Box mb={2}>
          <label className="field_label">
            {t("labels.subject")}
            {formValues.request_type === "GENERIC_HR" && (
              <span style={{ color: "red" }}> *</span>
            )}
          </label>
          <input
            type="text"
            name="subject"
            value={formValues.subject}
            onChange={handleChange}
            className="project_input"
            style={{ height: 40, width: "100%", marginTop: 6 }}
          />
        </Box>
{/* File Upload */}
<Box mb={2}>
  <CustomText
    sx={{
      fontSize: 16,
      fontWeight: 500,
      mb: 1,
      color: "#172B4D",
      textAlign: "left",
      fontFamily: "Poppins, sans-serif",
    }}
  >
    {t("proof")}
  </CustomText>
<Box
  sx={{
    border: "2px dashed #ccc",
    borderRadius: 2,
    p: 2,
      mt: 1,
    textAlign: "center",
      minHeight: "120px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    backgroundColor: file ? "#F9FAFB" : "transparent",
  }}
>
  {uploading ? (
    <CircularProgress size={24} />
  ) : !file ? (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*,application/pdf"
        style={{ display: "none" }}
        onChange={handleFileInputChange}
      />

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <Typography
          sx={{
            color: "#172B4D",
            fontWeight: 500,
            fontSize: "14px",
            fontFamily: "Poppins, sans-serif",
            mb: 1,
          }}
        >
          {t("cancelRequestModal.uploadPrompt") || "Upload File"}
        </Typography>
        
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setCameraOpen(true)}
            sx={{
              fontFamily: "Poppins, sans-serif",
              textTransform: "capitalize",
              color: "#006EC2",
              borderColor: "#006EC2",
              "&:hover": {
                borderColor: "#0056A3",
                backgroundColor: "#E3F2FD",
              },
            }}
          >
       {t("Take Photo")}
          </Button>
          
          <Button
            variant="outlined"
            onClick={triggerFileSelect}
            sx={{
              fontFamily: "Poppins, sans-serif",
              textTransform: "capitalize",
              color: "#006EC2",
              borderColor: "#006EC2",
              "&:hover": {
                borderColor: "#0056A3",
                backgroundColor: "#E3F2FD",
              },
            }}
          >
           {t("Choose File")}
          </Button>
        </Box>
      </Box>
    </>
  ) : (
    <Box
      sx={{
        width: "100%",
        textAlign: "center",
        wordBreak: "break-all",
        position: "relative",
      }}
    >
       <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
    <img
      src={
        file.type === "application/pdf"
          ? document1 /* PDF icon */
          : imageicon   /* Image icon */
      }
      alt="file-icon"
      style={{ width: 30, height: 30, objectFit: "contain" }}
    />
  </Box>

  {/* File Name */}
  <Typography
    sx={{
      color: "#172B4D",
      fontWeight: 500,
      fontSize: "14px",
      fontFamily: "Poppins, sans-serif",
    }}
  >
    {file.name}
  </Typography>

  {/* View Document Button for PDFs */}
  {file.type === "application/pdf" && formValues.file_url && (
    <Box sx={{ mt: 1, display: "flex", justifyContent: "center" }}>
      <CustomButton
        label={t("requestDetails.viewDocument") || "View Document"}
        size="small"
        onClick={() =>
          window.open(formValues.file_url, "_blank", "noopener,noreferrer")
        }
        sx={{
          fontSize: "12px",
          px: 2,
          py: 0.5,
        }}
      />
    </Box>
  )}

      {/* Delete (×) Icon */}
      <Box
        component="span"
        onClick={() => {
          console.log("❌ File removed");
          setFile(null);
          setFormValues((prev) => ({ ...prev, file_url: "" }));
        }}
        sx={{
          position: "absolute",
          top: -20,
          right: -8,
          width: 22,
          height: 22,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          backgroundColor: "#FF4C4C",
          color: "white",
          fontSize: 14,
          cursor: "pointer",
          "&:hover": { backgroundColor: "#E03E3E" },
        }}
      >
        ×
      </Box>
    </Box>
  )}
</Box>
</Box>

{/* Camera Modal */}
<Modal open={cameraOpen} onClose={() => setCameraOpen(false)}>
  <Box
    sx={{
      bgcolor: "white",
      p: 3,
      borderRadius: 3,
      maxWidth: 400,
      mx: "auto",
      mt: 10,
      textAlign: "center",
    }}
  >
    <Typography
      sx={{
        fontSize: "18px",
        fontWeight: 600,
        mb: 2,
        fontFamily: "Poppins, sans-serif",
      }}
    >
      {t("requests.takePhoto") || "Take Photo"}
    </Typography>

    <Webcam
      ref={webcamRef}
      audio={false}
      screenshotFormat="image/jpeg"
      width="100%"
    />

    <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 2 }}>
      <Button
        sx={{
          fontFamily: "Poppins, sans-serif",
          textTransform: "capitalize",
        }}
        variant="outlined"
        onClick={() => setCameraOpen(false)}
      >
        {t("evidenceModal.cancel") || "Cancel"}
      </Button>

      <Button
        sx={{
          fontFamily: "Poppins, sans-serif",
          textTransform: "capitalize",
        }}
        variant="contained"
        onClick={handleCapturePhoto}
      >
        {t("evidenceModal.capture") || "Capture"}
      </Button>
    </Box>
  </Box>
</Modal>



        {/* CONDITIONAL FIELDS */}
        {formValues.request_type === "LEAVE" && (
          <>
        
            <Box mb={2}>
  <label className="field_label">
    {t("labels.leaveReasonCode")} <span style={{ color: "red" }}>*</span>
  </label>
  <SelectDropdown
    name="leave_reason_code"
    values={formValues.leave_reason_code ? [formValues.leave_reason_code] : []}
    onChange={handleDropdownChange}
    options={[
      { label: t("options.leaveReasonCodes.urgent"), value: "URGENT" },
      { label: t("options.leaveReasonCodes.sick"), value: "SICK" },
      { label: t("options.leaveReasonCodes.vacation"), value: "VACATION" },
      { label: t("options.leaveReasonCodes.others"), value: "OTHER" },
    ]}
  />
</Box>
         {/* Leave Dates */}
<Box display="flex" gap={2} mb={2}>
  <Box flex={1}>
    <label className="field_label">
      {t("labels.startDate")} <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="date"
      name="start_date"
      value={formValues.start_date}
      onChange={handleChange}
      className="project_input"
      style={{ height: 40, width: "100%", marginTop: 6 }}
    />
  </Box>
  <Box flex={1}>
    <label className="field_label">
      {t("labels.endDate")} <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="date"
      name="end_date"
      value={formValues.end_date}
      onChange={handleChange}
      className="project_input"
      style={{ height: 40, width: "100%", marginTop: 6 }}
    />
  </Box>
</Box>

        {/* Partial Day Section */}
<Box
  mb={2}
  display="flex"
  alignItems="center"
  justifyContent="space-between"
>
      <label style={{ display: "flex", alignItems: "center", gap: 6 }}>

    <span>{t("labels.halfDayLeave") || "Half Day Leave"}</span>
  </label>
    <input
      type="checkbox"
      name="partial"
      checked={formValues.partial}
      onChange={handleChange}
    />

</Box>

{formValues.partial && (
  <Box display="flex" gap={2} mb={2}>
    <Box flex={1}>
      <label className="field_label">
        {t("labels.partialStart")} <span style={{ color: "red" }}>*</span>
      </label>
      <input
        type="time"
        name="partial_start"
        value={formValues.partial_start}
        onChange={handleChange}
        className="project_input"
        style={{ height: 40, width: "100%", marginTop: 6 }}
      />
    </Box>
    <Box flex={1}>
      <label className="field_label">
        {t("labels.partialEnd")} <span style={{ color: "red" }}>*</span>
      </label>
      <input
        type="time"
        name="partial_end"
        value={formValues.partial_end}
        onChange={handleChange}
        className="project_input"
        style={{ height: 40, width: "100%", marginTop: 6 }}
      />
    </Box>
  </Box>
)}
            <Box mb={2} sx={{display:"flex",flexDirection:"column"}}>
              <label>{t("labels.reason")}</label>
              <textarea
                name="reason"
                value={formValues.reason}
                onChange={handleChange}
                rows={3}
                className="project_input"
              />
            </Box>
          </>
        )}

        {formValues.request_type === "SCHEDULE_CHANGE" && (
          <>
            <Box mb={2}>
              <label>
                {t("labels.currentDays")} <span style={{ color: "red" }}>*</span>
              </label>
              <SelectDropdown
                name="current_days"
                values={formValues.current_days}
                onChange={handleMultiSelectChange}
                multiple={true}
                options={[
                  { label: "Mon", value: "MON" },
                  { label: "Tue", value: "TUE" },
                  { label: "Wed", value: "WED" },
                  { label: "Thu", value: "THU" },
                  { label: "Fri", value: "FRI" },
                ]}
              />
            </Box>
      <Box display="flex" gap={2} mb={2}>
  <Box flex={1}>
    <label className="field_label">
      {t("labels.currentStartTime")} <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="time"
      name="current_start_time"
      value={formValues.current_start_time}
      onChange={handleChange}
      className="project_input"
      style={{ height: 40, width: "100%", marginTop: 6 }}
    />
  </Box>
  <Box flex={1}>
    <label className="field_label">
      {t("labels.currentEndTime")} <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="time"
      name="current_end_time"
      value={formValues.current_end_time}
      onChange={handleChange}
      className="project_input"
      style={{ height: 40, width: "100%", marginTop: 6 }}
    />
  </Box>
</Box>
            <Box mb={2} flex={1}>
              <label>
                {t("labels.effectiveFrom")} <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="date"
                name="effective_from"
                value={formValues.effective_from}
                onChange={handleChange}
                  className="project_input"
      style={{ height: 40, width: "100%", marginTop: 6 }}
              />
            </Box>
            <Box mb={2} sx={{display:"flex",flexDirection:"column"}}>
              <label>{t("labels.details")}</label>
              <textarea
                name="reason"
                value={formValues.reason}
                onChange={handleChange}
                rows={3}
                className="project_input"
              />
            </Box>
          </>
        )}

        {formValues.request_type === "GENERIC_HR" && (
          <>
            <Box mb={2} sx={{display:"flex",flexDirection:"column"}}>
              <label>
                {t("labels.details")} <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                name="description"
                value={formValues.description}
                onChange={handleChange}
                rows={4}
                className="project_input"
              />
            </Box>

          </>
        )}





        {/* Save Button */}
        <CustomButton
          label={
            saving ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress size={16} sx={{ color: "white" }} />
                {t("actions.send")}
              </Box>
            ) : (
              t("actions.send")
            )
          }
          sx={{ mt: 1 }}
          onClick={handleSave}
          size="small"
          disabled={saving}
        />
      </Box>
    </Drawer>
  );
};

export default GenerateRequestDrawer;
